import React from 'react';
import { Times } from 'styled-icons/fa-solid/Times';

import { BaseBox, Button } from 'src/kit';

export const RemoveButton = ({ onClick, ...styledProps }) => {
  return (
    <Button onClick={onClick} variant="secondary" size="md" px={15} borderRadius="4px" {...styledProps}>
      <BaseBox as={Times} mr={5} size={12} />
      Remove
    </Button>
  );
};
